import { ProductData } from "../types/schema.types";
import { OfferItemCondition } from "schema-dts";
import { getBrandUrl } from "./helpers";
import type { CatalogBrandWithSlug, Gender } from "src/types/product-listing";
import type { CatalogProduct } from "src/types/graphql.d";

export interface ProductTransformerConfig {
  baseUrl?: string;
  defaultCurrency?: string;
  sellerName?: string;
  gender?: Gender;
  locale?: string;
}

export function transformProductToProductData(
  product: CatalogProduct,
  config: ProductTransformerConfig = {}
): ProductData {
  const {
    baseUrl = "",
    defaultCurrency = "EUR",
    sellerName = "Otrium",
    gender = "women",
    locale = "en-gb",
  } = config;

  const productUrl = baseUrl ? `${baseUrl}/product/${product.slug}` : "";

  const brandSlug = (product.brand as CatalogBrandWithSlug)?.slug ?? "";

  const productData: ProductData = {
    name: product.name,
    description: "",
    images: product.thumbnail ? [product.thumbnail] : [],
    sku: "",
    brand: product.brand?.name ?? "",
    brandUrl: getBrandUrl(brandSlug, locale),
    price: product.price,
    regularPrice: product.regular_price,
    currency: product.currency?.code || defaultCurrency,
    availability: "InStock",
    url: productUrl,
    gtin: undefined,
    mpn: undefined,
    color: undefined,
    material: undefined,
    size: undefined,
    rating: undefined,
    condition: "https://schema.org/NewCondition" as OfferItemCondition,
    category: "",
    careInstructions: undefined,
    variations: undefined,
    labels: undefined,
    status: "active",
    dateCreated: undefined,
    dateModified: undefined,
    gate: product.gate?.toString(),
    shopType: (product.product_shop_type ?? [gender]).filter(
      (value): value is string => typeof value === "string"
    ),
    kidsGender: undefined,
    seller: sellerName,
    sellerUrl: baseUrl,
    buyActionUrl: productUrl,
  };

  return productData;
}
